import { withStyles } from "@material-ui/core";
import React from "react";
import TrapData from "./TrapDetails.json";
import TrapBills from "./TrapBills";
import TrapTrailers from "./TrapTrailers";
const styles = (theme) => ({
  button: {
    marginLeft: 16,
  },
  paperAnchor: {
    position: "absolute",
    padding: 0,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    boxShadow: "none",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.gridBGColor,
    transform: "translate(0px, 0px)",
    transition: theme.transitions.create(["width"], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  paperHidden: {
    height: 0,
    width: 0,
  },
  backdrop: {
    position: "absolute",
    backgroundColor: "transparent",
  },
  modal: {
    position: "absolute",
  },
});

class TrapDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trapDetails: null,
      openLayover: false,
      selectedPros: [],
      selectedBatch: null,
      selectedBatches: [],
    };
  }

  componentDidMount() {
    const formattedIBData = TrapData.map((data) => {
      const selectedPros = this.getSelectedProIdsInBatch(data.bills);
      return {
        ...data,
        id: `${data.trailerNumber}${data.manifestNumber}`,
        selectedPros,
        isSelected: selectedPros.length === data.bills.length,
        isIntermediate:
          selectedPros.length > 0 && selectedPros.length < data.bills.length,
      };
    });
    setTimeout(() => {
      this.setState({
        trapDetails: formattedIBData,
      });
    }, 1000);
  }

  getSelectedProIdsInBatch = (batchPros) => {
    if(this.props.selectedShipmentIds?.length){
      return batchPros
        .filter((pro) => this.props.selectedShipmentIds.includes(pro.proId))
        .map((pro) => pro.proId);
    }
    return [];
  }

  showTrapBills = (selectedBatch) => {
    this.setState({
      openLayover: true,
      selectedBatch,
    });
  };

  closeOverlay = () => {
    this.setState({
      openLayover: false,
    });
  };

  updateSelectedBatches = (selectedBatch) => {
    const updatedData = this.state.trapDetails.map((batch) => {
      if (batch.id === selectedBatch.id) {
        const isSelectedAlready = batch.isSelected;
        const selectedBills = isSelectedAlready
          ? []
          : batch.bills.map((bill) => bill.proId);
        return {
          ...batch,
          isSelected: !isSelectedAlready,
          selectedPros: selectedBills,
          isIntermediate: false,
        };
      }
      return batch;
    });
    this.setState({
      trapDetails: updatedData,
    });
  };

  updateSelectedBills = (selectedPros) => {
    const updatedData = this.state.trapDetails.map((batch) => {
      if (batch.id === this.state.selectedBatch.id) {
        return {
          ...batch,
          isSelected: selectedPros.length === batch.bills.length,
          selectedPros: selectedPros.map((bill) => bill.proId),
          isIntermediate:
            selectedPros.length > 0 && selectedPros.length < batch.bills.length,
        };
      }
      return batch;
    });
    this.setState({
      trapDetails: updatedData,
      openLayover: false,
    });
  };

  getAllSelectedShipments = () => {
    const selectedShipments = this.state.trapDetails.reduce((acc, data) => {
      return [...acc, ...data.selectedPros];
    }, []);
    return selectedShipments
  }

  handleSubmit = () => {
    this.props.handleSubmit(this.getAllSelectedShipments());
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <TrapTrailers
          data={this.state.trapDetails}
          glEventHub={this.props.glEventHub}
          showTrapBills={this.showTrapBills}
          goBack={this.props.goBack}
          updateSelectedBatches={this.updateSelectedBatches}
          handleSubmit={this.handleSubmit}
        />
        {this.state.openLayover && (
          <TrapBills
            data={this.state.selectedBatch.bills}
            selectedPros={this.state.selectedBatch.selectedPros}
            glEventHub={this.props.glEventHub}
            onSubmit={this.updateSelectedBills}
            onCancel={this.closeOverlay}
            open
            anchor="bottom"
            variant="persistent"
            drawerClasses={{
              paper: `${classes.paperAnchor} customScroll ${
                !this.state.openLayover ? classes.paperHidden : ""
              }`,
              modal: classes.modal,
            }}
            BackdropProps={{
              className: classes.backdrop,
            }}
          />
        )}
      </>
    );
  }
}

export default withStyles(styles)(TrapDetails);
